import { render, staticRenderFns } from "./ProjectDetailsOverlay.vue?vue&type=template&id=e6283ac0&scoped=true"
import script from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDetailsOverlay.vue?vue&type=style&index=0&id=e6283ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6283ac0",
  null
  
)

export default component.exports